import { useState, useEffect } from 'react';
import { FirebaseOrder } from '@/models/order';
import { OrderRepository } from '@/services/firebase/order-repository';

/**
 * Hook pour récupérer une commande par son ID
 */
export const useOrder = (orderId: string | null) => {
  const [order, setOrder] = useState<FirebaseOrder | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!orderId) {
      setOrder(null);
      setLoading(false);
      return;
    }

    let isMounted = true;

    const fetchOrder = async () => {
      try {
        setLoading(true);
        setError(null);
        const fetchedOrder = await OrderRepository.getOrder(orderId);
        
        if (isMounted) {
          setOrder(fetchedOrder);
        }
      } catch (err) {
        console.error('Error fetching order:', err);
        if (isMounted) {
          setError('Failed to fetch order');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchOrder();

    return () => {
      isMounted = false;
    };
  }, [orderId]);

  return { order, loading, error };
};

